import classnames from 'classnames';

import { config } from 'ENV_CONFIG';
import { Section } from '~/components';
import styles from './AnalyticsQuestionsSection.scss';

export const AnalyticsQuestionsSection = () => (
  <div className={classnames(styles.AnalyticQuestionsSection, styles.Dark)}>
    <Section
      key=""
      title=""
      questions={config.howDidYouHearAboutOurServiceAnalyticsQuestions}
      formName="AboutYouFormState"
      errorMessage="error"
      formSectionName="analyticsQuestionSection"
      dataTest="analyticsQuestionsSection"
      extraClassName={styles.Container}
    />
  </div>
);
